import React, { ReactNode } from 'react'

interface ContentWrapperProps {
  children: ReactNode
  className?: string
}

export const ContentWrapper: React.FC<ContentWrapperProps> = ({ children, className = '' }) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {children}
        </div>
      </div>
    </div>
  )
}
